import { make } from "vuex-pathify";
import { getAPI, postAPI } from "@/store/restAPI.js"; // eslint-disable-line

const state = {
  globalParameters: [],
  loading:[],
};

const getters = {};

const actions = {
  // to be called once
  retrieve({ commit }) {
    commit("SET_LOADING", true);
    return getAPI("parameters/globalParameters")
    .then(response => commit("SET_GLOBAL_PARAMETERS", response))
      .finally(()=>{
        commit("SET_LOADING", false);
      });
  },

  // to be called as needed
  suggestCountries() {
    return getAPI("geography/suggestions/countries");
  },
  suggestCities(_, country) {
    return getAPI("geography/suggestions/cities", { country });
  },
  suggestDistricts(_, city) {
    return getAPI("geography/suggestions/districts", { city });
  },
  suggestVillages(_, district) {
    return getAPI("geography/suggestions/villages", { district });
  },
  suggestBranches() {
    return getAPI("geography/suggestions/branches");
  },
  suggestZipCodes(_, locationInfo) {
    return getAPI("geography/suggestions/zipcodes", locationInfo);
  },
};

// mutations
const mutations = {
  ...make.mutations(state)
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
